export const apiKey = "57bfff0eb99c4410o19bd76a18tf36ea";
export const myCitiesArray = ["Eindhoven", "Kharkiv", "Amsterdam", "Kyiv"];
export const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const months = ["January", "February", "March", "April", "May", "June", "Julay", "August", "September", "October", "November", "December"];

export const iconsMapping = {
      'clear-sky-day': {icon: 'CLEAR_DAY', color: '#F78640'},
      'clear-sky-night': {icon: 'CLEAR_NIGHT', color: '#514A83'},
      'few-clouds-day': {icon: 'PARTLY_CLOUDY_DAY', color: 'goldenrod'},
      'few-clouds-night': {icon: 'PARTLY_CLOUDY_NIGHT', color: '#514A83'},
      'scattered-clouds-day': {icon: 'CLOUDY', color: '#7DC9F6'},
      'scattered-clouds-night': {icon: 'CLOUDY', color: '#514A83'},
      'broken-clouds-day': {icon: 'CLOUDY', color: '#c2b6d6'},
      'broken-clouds-night': {icon: 'CLOUDY', color: '#514A83'},
      'shower-rain-day': {icon: 'RAIN', color: '#cab3cc'},
      'shower-rain-night': {icon: 'RAIN', color: '#514A83'},
      'rain-day': {icon: 'RAIN', color: '#77d6ce'},
      'rain-night': {icon: 'RAIN', color: '#514A83'},
                  'thunderstorm-day': {icon: 'RAIN',
            color: '#AAAAAA'},
                  'thunderstorm-night': {icon: 'RAIN',
            color: '#514A83'},
                  'snow-day': {icon: 'SNOW',
            color: '#99c3db'},
                  'snow-night': {icon: 'SNOW',
            color: '#514A83'},
                  'mist-day': {icon: 'FOG',
            color: '#84cdd8'},
                  'mist-night': {icon: 'FOG',
            color: '#514A83'}
};

export const iconsArray = [
        {desc: 'clear-sky-day',icon: 'CLEAR_DAY',
  color: '#F78640'},
        {desc: 'clear-sky-night',icon: 'CLEAR_NIGHT',
  color: '#514A83'},
        {desc: 'few-clouds-day',icon: 'PARTLY_CLOUDY_DAY',
  color: 'goldenrod'},
        {desc: 'few-clouds-night',icon: 'PARTLY_CLOUDY_NIGHT',
  color: '#514A83'},
       {desc: 'scattered-clouds-day',icon: 'CLOUDY',
  color: '#7DC9F6'},
        {desc: 'scattered-clouds-night',icon: 'CLOUDY',
  color: '#514A83'},
        {desc: 'broken-clouds-day',icon: 'CLOUDY',
  color: '#c2b6d6'},
        {desc: 'broken-clouds-night',icon: 'CLOUDY',
  color: '#514A83'},
        {desc: 'shower-rain-day',icon: 'RAIN',
  color: '#cab3cc'},
        {desc: 'shower-rain-night',icon: 'RAIN',
  color: '#514A83'},
        {desc: 'rain-day',icon: 'RAIN',
  color: '#77d6ce'},
        {desc: 'rain-night',icon: 'RAIN',
  color: '#514A83'},
        {desc: 'thunderstorm-day',icon: 'RAIN',
  color: '#AAAAAA'},
        {desc: 'thunderstorm-night',icon: 'RAIN',
  color: '#514A83'},
        {desc: 'snow-day',icon: 'SNOW',
  color: '#99c3db'},
        {desc: 'snow-night',icon: 'SNOW',
  color: '#514A83'},
        {desc: 'mist-day',icon: 'FOG',
  color: '#84cdd8'},
        {desc: 'mist-night',icon: 'FOG',
  color: '#514A83'}];

